class NewsletterForm extends HTMLElement {
  constructor() {
    super();
    this.womensInput = this.querySelector('#NewsletterForm-GenderFemale');
    this.mensInput = this.querySelector('#NewsletterForm-GenderMale');
    this.allInput = this.querySelector('#NewsletterForm-GenderAll');
    this.emailInput = this.querySelector('input[type="email"][id^="NewsletterForm"]');

    this.checkboxError = this.querySelector('#newsletter_gender_error_msg');
    this.inputError = this.querySelector('#Newsletter-error--email');

    this.submitButton = this.querySelector('#NewsletterForm-Submit');
    this.tagInput = this.querySelector('#NewsletterForm-Tags');
  }

  connectedCallback() {
    this.womensInput.addEventListener('change', this.onGenderChange.bind(this));
    this.mensInput.addEventListener('change', this.onGenderChange.bind(this));
    this.allInput.addEventListener('change', this.onGenderChange.bind(this));
    this.emailInput.addEventListener('keyup', this.checkEmailValidity.bind(this));
  }

  checkEmailValidity() {
    const email = this.emailInput.value;

    if (email.length > 2) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const isValid = emailRegex.test(email);
        if (!isValid) {
          this.inputError.classList.remove('hidden');
        } else {
          this.inputError.classList.add('hidden');
          if (this.checkboxError.classList.contains('hidden')) {
            this.submitButton.removeAttribute('disabled');
          }
        }
      }, 300);

      if (!this.womensInput.checked && !this.mensInput.checked && !this.allInput.checked) {
        this.checkboxError.classList.remove('hidden');
      } else {
        this.checkboxError.classList.add('hidden');
      }
    } else {
      this.inputError.classList.add('hidden');
    }
  }

  onGenderChange(event) {
    let womensInputChecked = this.womensInput.checked;
    let mensInputChecked = this.mensInput.checked;
    let allInputChecked = this.allInput.checked;

    if (
      (womensInputChecked || mensInputChecked || allInputChecked) &&
      this.emailInput.value.length > 2 &&
      this.inputError.classList.contains('hidden')
    ) {
      this.submitButton.removeAttribute('disabled');
    } else {
      this.submitButton.setAttribute('disabled', true);
    }

    if (!womensInputChecked && !mensInputChecked && !allInputChecked && this.emailInput.value.length > 2) {
      this.checkboxError.classList.remove('hidden');
    } else {
      this.checkboxError.classList.add('hidden');
    }

    let tagString = 'Newsletter, ';

    if (allInputChecked && event.target.value === 'All') {
      tagString += 'Womens, Mens, ';
      this.womensInput.checked = true;
      this.mensInput.checked = true;
    } else if (allInputChecked && (!womensInputChecked || !mensInputChecked)) {
      this.allInput.checked = false;
      allInputChecked = false;
    }

    if (!allInputChecked && womensInputChecked) {
      tagString += 'Womens, ';
    }

    if (!allInputChecked && mensInputChecked) {
      tagString += 'Mens, ';
    }

    tagString += 'WEB_FOOTER';

    this.tagInput.value = tagString;
  }
}

customElements.define('newsletter-form', NewsletterForm);
